import { authFetch } from "@/plugins/axiosConfig";

const manualStore = {
  namespaced: true,
  state: {
    long: {
      BTCUSDT: 0,
      ETHUSDT: 0,
      XRPUSDT: 0,
      SOLUSDT: 0,
      ADAUSDT: 0,
      DOGEUSDT: 0,
      BNBUSDT: 0,
    },
    short: {
      BTCUSDT: 0,
      ETHUSDT: 0,
      XRPUSDT: 0,
      SOLUSDT: 0,
      ADAUSDT: 0,
      DOGEUSDT: 0,
      BNBUSDT: 0,
    },
  },
  getters: {
    GT_LONG_MANUAL: (state) => state.long,
    GT_SHORT_MANUAL: (state) => state.short,
  },
  mutations: {
    MU_UPDATE_MANUAL: (state, payload) => {
      for (let i = 0; i < payload.length; i++) {
        const _positionSide = payload[i].positionSide.toLowerCase();
        state[_positionSide][payload[i].symbol] = payload[i].stop ? 1 : 0;
      }
    },
    MU_UPDATE_M_SINGLE: (state, payload) => {
      state[payload.position][payload.symbol] = payload.isStop ? 1 : 0;
    },
  },
  actions: {
    AT_GET_MANUAL: async ({ commit }) => {
      const response = await authFetch.get(`/api/order/manual/trade/all`);
      if (response.status === 200) {
        commit("MU_UPDATE_MANUAL", response.data);
      } else {
        alert(
          "거래 컨트롤 정보를 조회하는 중 오류가 발생했습니다. 잠시 후 다시 시도해주시기 바랍니다"
        );
      }
    },
  },
};

export default manualStore;
